import { atom, selector } from "recoil";

const csRevisionState = atom({
  key: 'csRevisionState',
  default: 0
});

export const csRevision = selector({
  key: 'csRevision',
  get: ({get}) => get(csRevisionState),
  set: ({set, get}) => set(csRevisionState, get(csRevisionState) + 1)
});
